export default __webpack_public_path__ + "static/media/signupImage1.867fbe04.webp";